import React from 'react'
import UnderCunstruction from '../../../../components/ui/underCunstruction/UnderCunstruction'

const MyTeamWorkReview = () => {
  return (
    // <div>MyTeamWorkReview</div>
    <UnderCunstruction />
  )
}

export default MyTeamWorkReview